export default __webpack_public_path__ + "static/media/cpr3.8dd2eb95.jpg";